
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button.vue";
  import ManagerInvite from "@/components/managers/ManagerInvite.vue";
  import PlusIcon from "@/components/icons/PlusIcon.vue";
import ManagerAddonModal from "@/components/managers/ManagerAddonModal.vue";
import { Company, User } from "@/generated/graphql";


  @Component({
    components: {
      UiButton,
      ManagerInvite,
      PlusIcon,
    ManagerAddonModal
    },
  })
  export default class ManagerInvitationModalWithButton extends Vue {
    @Prop({type: String, required: true}) readonly companyId!: string;
    @Prop({type: String, required: true}) readonly companyBusinessName!: string;
    @Prop({type: String, default: "project"}) readonly size?: string;
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: Boolean, default: false}) readonly managersUnlimited!: boolean;
    @Prop({type: Number, required: true}) readonly activeManagersCount!: number;
    @Prop({type: Number, required: true}) readonly accessAllowedManagersCount!: number;
 
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

    contractorDialog: boolean = false;
  managerAddonPopup: boolean = false;

    showInviteModal(): void {
      if (this.isDisabled) {
        return;
      }

      this.contractorDialog = true;
    }

    get isDisabled(): boolean {
      return this.disabled || !this.companyId;
    }

    openManagerAddonModal(): void {
    this.contractorDialog = false;
    this.managerAddonPopup = true;
  }

  closeManagerAddonModal(): void {
    this.contractorDialog = true;
    this.managerAddonPopup = false;
  }

  openManagerAddonModalAndCloseSubscriptionActionModalClose():void {
    this.managerAddonPopup = true;
  }
  }
